"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSwipe = exports.default = void 0;
var _react = require("react");
/**
 * useSwipe - React Hook for detecting swipe gestures on a specified DOM element.
 *
 * @example
 * // Usage in a functional component:
 * const myRef = useRef(null);
 *
 * useSwipe({
 *   ref: myRef,
 *   onRightSwipe: () => console.log('Right swipe detected!'),
 *   onLeftSwipe: () => console.log('Left swipe detected!'),
 *   onUpSwipe: () => console.log('Up swipe detected!'),
 *   onDownSwipe: () => console.log('Down swipe detected!'),
 * });
 *
 * return <div ref={myRef}>Swipe me!</div>;
 */
const useSwipe = ({
  ref,
  onRightSwipe,
  onLeftSwipe,
  onDownSwipe,
  onUpSwipe
}) => {
  const startCoords = (0, _react.useRef)({
    x: null,
    y: null
  });
  const minSwipeDistance = 50; // Minimum distance to consider as a swipe
  (0, _react.useEffect)(() => {
    const handleTouchStart = e => {
      startCoords.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
    };
    const handleTouchEnd = e => {
      const {
        x: startX,
        y: startY
      } = startCoords.current;
      if (startX === null || startY === null) {
        return;
      }
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const deltaX = endX - startX;
      const deltaY = endY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > minSwipeDistance) {
          onRightSwipe === null || onRightSwipe === void 0 ? void 0 : onRightSwipe();
        } else if (deltaX < -minSwipeDistance) {
          onLeftSwipe === null || onLeftSwipe === void 0 ? void 0 : onLeftSwipe();
        }
      } else if (deltaY > minSwipeDistance) {
        onDownSwipe === null || onDownSwipe === void 0 ? void 0 : onDownSwipe();
      } else if (deltaY < -minSwipeDistance) {
        onUpSwipe === null || onUpSwipe === void 0 ? void 0 : onUpSwipe();
      }
      // Reset startCoords
      startCoords.current = {
        x: null,
        y: null
      };
    };
    const node = ref.current;
    if (node) {
      node.addEventListener('touchstart', handleTouchStart);
      node.addEventListener('touchend', handleTouchEnd);
      return () => {
        node.removeEventListener('touchstart', handleTouchStart);
        node.removeEventListener('touchend', handleTouchEnd);
      };
    }
    return () => {};
  }, [ref]);
};
exports.useSwipe = useSwipe;
var _default = exports.default = useSwipe;